export default "__VITE_ASSET__WtD0SGxw__"